export default __webpack_public_path__ + "static/media/typeCrane.8b60fca3.svg";